import { TOGGLE_MODAL } from '../actions/modals'

const initialState = {}
const modals = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MODAL:
      return {
        ...state,
        [action.pageId]: {
          selectedModal: action.modalName
        }
      }
    default:
      return state
  }
}

export default modals
